<template>
  <div style="font-size: 14px;">
    <div class="row mx-0 bg-primary text-white px-4 pt-4 pb-2">
      <div class="col-12 px-0">
        <h3>ログインしてたくさんの漫画をオトクに楽しもう</h3>
      </div>
    </div>
    <div class="bg-white p-2 border mb-3 row mx-0">
      <div class="col-12 text-center">
        <h3>①無料会員登録でもっと読める</h3>
      </div>
      <div class="col-12 text-center">
        <span>
          <strong>79,000話</strong>の<span class="text-ticket">待つと無料</span>
          漫画が読める！</span
        >
        <div class="mb-3">
          <img
            src="https://d1j7d76yk36xez.cloudfront.net/20200213/promote_login1.png"
            style="width: 100%; max-width: 400px; margin-top: 20px;"
          />
        </div>
        <div class="small text-danger mb-3">
          セールには会員限定で無料作品も豊富にあります
        </div>
      </div>
    </div>
    <div class="bg-white p-2 border mb-3 row mx-0">
      <div class="col-12 text-center">
        <h3>②チケットが貰える</h3>
      </div>
      <div class="col-12 col-md-6 mb-3 text-center" style="border-right: 1px solid #EEE">
        <strong class="text-ticket">作品専用チケット</strong
        >で複数の作品が1日1話ずつ読める
        <img
          src="https://d1j7d76yk36xez.cloudfront.net/20200213/promote_login4-3.png"
          style="width: 100%; max-width: 400px;"
        />
      </div>
      <div class="col-12 col-md-6 mb-3 text-center">
        1日3枚の<strong class="text-ticket">ボーナスチケット</strong
      >で一気読みも可能
        <img
          src="https://d1j7d76yk36xez.cloudfront.net/20200213/promote_login5-2.png"
          style="width: 100%; max-width: 250px;"
        />
      </div>
    </div>
    <div class="bg-white p-2 border mb-3 row mx-0">
      <div class="col-12 text-center">
        <h3>③本棚管理</h3>
      </div>
      <div class="col-12 col-md-6 text-center mb-3" style="border-right: 1px solid #EEE">
        どこまで読んだか色分けですぐ分かる
        <img
          src="https://d1j7d76yk36xez.cloudfront.net/20200213/promote_login2.png"
          style="width: 100%; max-width: 400px;"
        />
      </div>
      <div class="col-12 col-md-6 w-md-50 mb-3 text-center">
        以前読んでいた作品を本棚からすぐに探せる
        <img
          src="https://d1j7d76yk36xez.cloudfront.net/20200213/promote_login3.png"
          style="width: 100%; max-width: 400px;"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Vuex from "vuex";

export default {
  methods: {
    ...Vuex.mapActions(["showLoginModal"])
  }
};
</script>
<style scoped lang="scss">
h3 {
  line-height: 1.7;
}

.w-50 {
  display: inline-block;
  width: 50%;
  @media screen and (max-width: 768px) {
    width: 100%;
    border: none !important;
  }
}

.bg-gray {
  background: rgba(0, 0, 0, .05);
}

.mb-3 {
  margin-bottom: 12px;
}

.px-4 {
  padding-right: 16px;
  padding-left: 16px;
}

.border {
  border: 1px solid rgba(0, 0, 0, .02);
}
</style>
